import * as React from 'react';
import { useEventCallback, useLightboxProps } from 'yet-another-react-lightbox';

export function useZoomCallback(zoom: number, disabled: boolean) {
  const { on } = useLightboxProps();

  const onZoomCallback = useEventCallback(() => {
    if (!disabled) {
      on.zoom?.({ zoom });
    }
  });

  React.useEffect(onZoomCallback, [zoom, onZoomCallback]);
}
